import React, { useContext } from 'react';
import WebinarsContext from 'webinars/context';
import LandingPageDetails from 'shared/components/LandingPageDetails';
import SupportingDocuments from 'shared/components/SupportingDocuments';
import { mixpanelEvents, mixpanelTrack } from 'utils/mixpanelHelpers';
import { headers } from 'webinars/shared/helpers';
import { basePath } from 'employee-pro-shared/constants';
import { useTranslation } from 'react-i18next';

import './styles';

const {
  webinars: { CLICK_DOWNLOAD_WEBINAR_PRESENTATION },
} = mixpanelEvents;

const WebinarDescription = () => {
  const { webinar = {} } = useContext(WebinarsContext);
  const { hasDocuments, name, encodedId } = webinar;
  const { t } = useTranslation();

  const downloadProps = {
    copy: t('Download support documents'),
    link: `${basePath}/download_documents?type=Webinar&encoded_id=${webinar.encodedId}`,
    onClick: () => {
      mixpanelTrack(CLICK_DOWNLOAD_WEBINAR_PRESENTATION, {
        encodedId,
        name,
      });
    },
  };

  return (
    <div className="webinar-description-wrapper">
      <LandingPageDetails headers={headers} event={webinar} />
      {hasDocuments && <SupportingDocuments {...downloadProps} />}
    </div>
  );
};

export default WebinarDescription;
